// src/Lexappstore/AppStore.jsx
import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, Link } from "react-router-dom";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import AppCard from "./appcard";
import "./AppStore.css";

// ← Exported module‐level fallback data for AppDetailPage
export const sampleApps = [
      {
    id: "link-flower",
    name: "Lex Link Flower",
    tagline: "One URL, every link in full bloom",
    description: "One URL, every link in full bloom",
    link: "/linkflower",
    pricing: {
      model: "subscription",
      monthlyPrice: 4.99,
      yearlyPrice: 49.99,
      stripePriceIdMonthly: "price_month_mail",
      stripePriceIdYearly: "price_year_mail",
      currency: "USD",
      paymentMethods: ["card", "paypal"]
    },
    },
    {
    id: "burner-chat",
    name: "Lex Burner Chat",
    tagline: "Anonymous self-destructing chat",
    description: "Anonymous self-destructing chat",
    link: "/burnerchat",
    pricing: {
      model: "subscription",
      monthlyPrice: 14.99,
      yearlyPrice: 149.99,
      stripePriceIdMonthly: "price_month_mail",
      stripePriceIdYearly: "price_year_mail",
      currency: "USD",
      paymentMethods: ["card", "paypal"]
    },
    },
  {
    id: "burner-call",
    name: "Lex Burner Call",
    tagline: "Destroy evidence, no trace",
    description: "Destroy evidence, 100% no trace",
    link: "/call",
    pricing: {
      model: "subscription",
      monthlyPrice: 14.99,
      yearlyPrice: 149.99,
      stripePriceIdMonthly: "price_month_mail",
      stripePriceIdYearly: "price_year_mail",
      currency: "USD",
      paymentMethods: ["card", "paypal"]
    },
  },
  {
    id: "auto-call",
    name: "Lex Auto Call",
    tagline: "The right call, the right time",
    description: "The right call, the right time",
    link: "/autocall",
    pricing: {
      model: "subscription",
      monthlyPrice: 9,
      yearlyPrice: 90,
      stripePriceIdMonthly: "price_month_123",
      stripePriceIdYearly: "price_year_123",
      currency: "USD",
      paymentMethods: ["card", "paypal"]
    },

  },
  {
    id: "lex-mail",
    name: "Lex Mail",
    tagline: "Tired of checking emails?",
    description: "Tired of checking emails?",
    link: "/mail",
    rating: 4.7,
    pricing: {
      model: "subscription",
      monthlyPrice: 12,
      yearlyPrice: 120,
      stripePriceIdMonthly: "price_month_mail",
      stripePriceIdYearly: "price_year_mail",
      currency: "USD",
      paymentMethods: ["card", "paypal"]
    },
  },
   {
    id: "prompt-note-taker",
    name: "Prompt Notebook",
    tagline: "Discover and save prompts",
    description: "Discover and share prompts",
    link: "/prompts/*",
    pricing: {
      model: "subscription",
      monthlyPrice: 2.99,
      yearlyPrice: 10,
      stripePriceIdMonthly: "price_month_mail",
      stripePriceIdYearly: "price_year_mail",
      currency: "USD",
      paymentMethods: ["card", "paypal"]
    },

  },
   {
    id: "screenshot-notebook",
    name: "Screenshot Notebook",
    tagline: "Analyze and share screenshots so easy",
    description: "Analyze and share screenshots",
    link: "/screenshot",
    pricing: {
      model: "subscription",
      monthlyPrice: 2.99,
      yearlyPrice: 10,
      stripePriceIdMonthly: "price_month_mail",
      stripePriceIdYearly: "price_year_mail",
      currency: "USD",
      paymentMethods: ["card", "paypal"]
    },

  },
  {
    id: "Youtube-to-mp3",
    name: "YouTube to MP3",
    tagline: "Extract audio from YouTube. Download and enjoy.",
    description: "Extract audio from YouTube. Download and enjoy.",
    link: "/yt-media",
    pricing: {
      model: "subscription",
      monthlyPrice: 2.99,
      yearlyPrice: 10,
      stripePriceIdMonthly: "price_month_mail",
      stripePriceIdYearly: "price_year_mail",
      currency: "USD",
      paymentMethods: ["card", "paypal"]
    },

  }

  
];

export default function AppStore() {
  const navigate = useNavigate();
  const [apps, setApps] = useState([]);
  const [activeTab, setActiveTab] = useState("featured");

  // Firestore listener; fall back to our exported sampleApps
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "lexApps"), (snap) => {
      const remote = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setApps(remote.length ? remote : sampleApps);
    });
    return () => unsub();
  }, []);

  // Navigation cards
  const navCards = useMemo(
    () => [
       {
      id: "__nav_promo1",
      name: "",
      description: "",
      icon: "https://firebasestorage.googleapis.com/v0/b/lextrack-ai.firebasestorage.app/o/1.png?alt=media&token=a79e3442-aef6-47f4-9d08-2eaaf0f437e1",
    },
    {
      id: "__nav_promo2",
      name: "",
      description: "",
      icon: "https://firebasestorage.googleapis.com/v0/b/lextrack-ai.firebasestorage.app/o/2.png?alt=media&token=02c54ef5-e97f-43fb-94ef-b83dbd2c4c54",
    },
    {
      id: "__nav_promo3",
      name: "",
      description: "",
      icon: "https://firebasestorage.googleapis.com/v0/b/lextrack-ai.firebasestorage.app/o/3.png?alt=media&token=6846ecae-b4cb-4aca-9891-7edf13abc88f",
    },
  {
      id: "__nav_promo4",
      name: "",
      description: "",
      icon: "https://firebasestorage.googleapis.com/v0/b/lextrack-ai.firebasestorage.app/o/4.png?alt=media&token=38286ea1-e824-4eaa-a857-7972c8e7ce35",
    },
    
      {
        id: "__nav_all",
        name: "All",
        description: "Unlock possibilities",
    
    
      }
    ],
    []
  );

  // Filter by tab
  const realApps =
    activeTab === "all"
      ? apps
      : apps.filter((a) => (a.status || "featured") === "featured");

  const displayApps = [...navCards, ...realApps];





  return (
    <div className="appstore-page-bg">
      <div className="appstore-container">
        <div className="appstore-banner">
          <Link to="/" className="appstore-back">← Back</Link>
          <div className="appstore-banner-content">
            <h1>AI App Store</h1>
            <p className="appstore-tagline">
              Discover, use, or build &amp; monetize AI-powered apps on Lex.
            </p>
            <button
              className="appstore-now-btn"
              onClick={() =>
                (window.location.href =
                  "https://lextrackai.com/partners/apply")
              }
            >
              Submit App
            </button>
          </div>
        </div>

        
    <div className="appstore-grid">
  {displayApps.map((app, idx) => {
    // 前 3 个 navCards：只渲染一个带背景的 div
    if (idx < navCards.length && idx < 4) {
      return (
        <div
          key={app.id}
          style={{
            width: "100%",
            paddingTop: "100%",            // 高度 = 宽度 → 保持正方形
            backgroundImage: `url(${app.icon})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            borderRadius: "8px",           // 同 AppCard 圆角
            overflow: "hidden",
          }}
        />
      );
    }
    // 其余卡片保持原样
    return (
      <AppCard
        key={app.id}
        id={app.id}
        link={app.link}
        title={app.name}
        description={app.description}
        imageUrl={app.icon}
      />
    );
  })}
</div>






        <div className="appstore-bottom-spacer" />
      </div>
    </div>
  );
}
